import {
  ListVoteTotals,
  ListItemVoteTotals,
  VotePercentages,
  PlacementVotePercentages,
} from "../types/votes";

export const calculateVotePercentages = (
  totals: ListVoteTotals,
): VotePercentages => {
  const totalVotes = totals.valid + totals.debatable + totals.trash;

  if (totalVotes === 0) {
    return { validPct: 0, debatablePct: 0, trashPct: 0 };
  }

  return {
    validPct: Math.round((totals.valid / totalVotes) * 100),
    debatablePct: Math.round((totals.debatable / totalVotes) * 100),
    trashPct: Math.round((totals.trash / totalVotes) * 100),
  };
};

export const calculatePlacementVotePercentages = (
  totals: ListItemVoteTotals,
): PlacementVotePercentages => {
  const totalVotes = totals.tooHigh + totals.rightSpot + totals.tooLow;

  if (totalVotes === 0) {
    return { tooHighPct: 0, rightSpotPct: 0, tooLowPct: 0 };
  }

  return {
    tooHighPct: Math.round((totals.tooHigh / totalVotes) * 100),
    rightSpotPct: Math.round((totals.rightSpot / totalVotes) * 100),
    tooLowPct: Math.round((totals.tooLow / totalVotes) * 100),
  };
};
